import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {__} from 'lodash/fp';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function multiSelectTaskReducer(state = initialState.multiSelectTasks, action) {
	switch (action.type) {
		case types.APPEND_MULTISELECT_TASK: {
			if (action.inputPayload && action.inputPayload.cleanSelectedTask) {
				return [action.payload];
			}
			const filteredState = _.filter(state, ({id}) => id !== action.payload.id);
			return [...filteredState, action.payload];
		}
		case types.APPEND_MULTISELECT_TASKS: {
			if (action.inputPayload && action.inputPayload.cleanSelectedTask) {
				return [action.payload];
			}
			const selectedTaskIds = [];
			_.forEach(action.payload, (task) => selectedTaskIds.push(task.id));
			const filteredState = _.filter(state, ({id}) => !_.includes(selectedTaskIds, id));
			return [...filteredState, ...action.payload];
		}
		case types.REMOVE_MULTISELECT_TASK: {
			if (action.inputPayload && action.inputPayload.cleanSelectedTask) {
				return [];
			}
			return _.filter(state, ({id}) => id !== action.payload.id);
		}

		case types.REMOVE_MULTISELECT_TASKS: {
			if (action.inputPayload && action.inputPayload.cleanSelectedTask) {
				return [];
			}
			const selectedTaskIds = [];
			_.forEach(action.payload, (task) => selectedTaskIds.push(task.id));
			var tasks = _.filter(state, ({id}) => !_.includes(selectedTaskIds, id));
			return tasks;
		}

		case types.ADD_MULTISELECT_TASK:
		case types.RESET_TASK_ATTRIBUTES:
		case types.RESET_MULTISELECT_TASK_ATTRIBUTES:
		case types.SET_MULTISELECT_TASK: {
			let tasks = Array.isArray(action.payload) ? action.payload : [action.payload];
			if (state.length > 0 && action.option && action.option.multiSelectOperation) {
				let taskIds = _.map(state, ({id}) => {
					return id;
				});

				let filteredList = _.filter(tasks, (item) => {
					return !taskIds.includes(item.id);
				});
				return [...filteredList, ...state];
			}
			return tasks;
		}
		case types.SET_IS_MULTISELECT_TASK:
		case types.SET_TASK_LIST_FILTERS:
			if (action.payload && action.payload.cleanSelectedTask) {
				return [];
			}
			return state;
		case types.CLEAN_MULTISELECT_TASK:
		case types.RESET_TASK_CATEGORY:
			return [];
		case types.TASK_LIST_LOADED:
			return action.taskId ? [] : state;
		case types.ASSOCIATE_TASK_TAG:
			if (!action.error) {
				let updatedState = [];
				if (action.payload.operation == 'Add') {
					updatedState = state.map((tg) => {
						if (action.payload.entitiesUIds.includes(tg.id)) {
							return {
								...(tg || []),
								tagsList: [...(tg.tagsList || []), buildTag(action.payload.tag, action.payload.tagGroup, tg.id)]
							};
						}

						return tg;
					});
				}

				if (action.payload.operation == 'Remove') {
					updatedState = state.map((tg) => {
						if (action.payload.entitiesUIds.includes(tg.id)) {
							return {
								...(tg || []),
								tagsList: tg.tagsList?.filter((item) => {
									return item.engagementTagId != action.payload.tag.tagId;
								})
							};
						}

						return tg;
					});
				}

				return updatedState;
			}

			return state;
		case types.DISASSOCIATE_TASK_TAG:
			if (!action.error) {
				let updatedStateTags = state.map((tg) => {
					if (tg.id == action.payload.entityUId) {
						return {
							...tg,
							tagsList: tg.tagsList.filter((item) => {
								return item.engagementTagId != action.payload.tag.tagId;
							})
						};
					}

					return tg;
				});

				return updatedStateTags;
			}

			return state;
		default:
			return state;
	}
}

export function buildTag(tag, tagGroup, taskId) {
	let taskTag = {
		colorCode: tag.colorCode,
		engagementTagGroupId: tagGroup.groupId,
		engagementTagGroupName: tagGroup.groupName,
		engagementTagId: tag.tagId,
		engagementTagName: tag.tagName,
		entityCount: 0,
		entityUIID: taskId
	};

	return taskTag;
}
